import {User} from '../model/models'

export default class UserLogic {
  static isContentCreator(user: User | null) {
    return UserLogic.userHasRole(user, 'CONTENT_CREATOR')
  }

  static isAdmin(user: User | null) {
   return UserLogic.userHasRole(user, 'SUPER_ADMIN')
  }
  
  private static userHasRole(user: User | null, role: string) : boolean {
    if (user === null || !user.roles || user.roles.length <= 0) {
      return false
    }
    return user.roles.includes(role)
  }
}
